import { render, staticRenderFns } from "./AIInspect.vue?vue&type=template&id=287e7b09"
import script from "./AIInspect.vue?vue&type=script&lang=js"
export * from "./AIInspect.vue?vue&type=script&lang=js"
import style0 from "./AIInspect.vue?vue&type=style&index=0&id=287e7b09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports